export interface RouteParcel
{
    controlNumber: number;
    accountNumber: number;
    trackingNumber: string;
    assignedRoute: string;
    scannedRoute: string;
    serviceType: string;
    parcelStatus: number;
    deliveryZip: string;
    canReroute: boolean;
    selected: boolean;
    deliveryDate: string;
}

export const getStatusName = (status: number): string =>
{
    switch(status)
    {
        case 0: return "Green scans";
        case 1: return "Red scans";
        case 2: return "Yellow scans";
        case 3: return "Inbound (blue)";
        case 4: return "Non-Inbound (white)";
        default: return "";
    }
}